import { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Chart2({ top3Equipos, loading }) {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
    },
  };

  useEffect(() => {
    if (!top3Equipos || top3Equipos === 'empty' || top3Equipos.length === 0) {
      setChartData({
        labels: [],
        datasets: [],
      });
      return;
    }

    const total = top3Equipos.reduce((sum, item) => sum + item.total_selecciones, 0);

    const labels = top3Equipos.map(item => {
      const porcentaje = ((item.total_selecciones / total) * 100).toFixed(1);
      return `${item.nombre_equipo} (${porcentaje}%)`;
    });

    const data = top3Equipos.map(item => item.total_selecciones);

    const baseColors = ['#858796', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b', '#5a5c69'];
    const repeatedColors = Array.from({ length: data.length }, (_, i) => baseColors[i % baseColors.length]);

    setChartData({
      labels,
      datasets: [
        {
          data,
          backgroundColor: repeatedColors,
        },
      ],
    });
  }, [top3Equipos]);

  const hasData = chartData.labels.length > 0 && chartData.datasets.length > 0;

  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <div style={{ width: '100%', maxWidth: '350px' }}>
        {loading ? (
          <Skeleton height={300} />
        ) : hasData ? (
          <Pie data={chartData} options={options} />
        ) : (
          <p>No hay datos para mostrar.</p>
        )}
      </div>
    </div>
  );
}